module.exports = __webpack_public_path__ + "static/img/c8m-lines.1324de06.png";